import script from "./NoteTypeCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteTypeCardModal.vue?vue&type=script&setup=true&lang=js"

import "./NoteTypeCardModal.vue?vue&type=style&index=0&id=6cace315&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cace315"]])

export default __exports__